<div class="tds-container-fluid">
    <div class="tds-landing-page__bgimage"></div>
</div>